export default __webpack_public_path__ + "static/media/cancelNegotiation.abd3c6eb.svg";